import { render } from "./dkyg.vue?vue&type=template&id=61f328d6&scoped=true"
const script = {}

import "./dkyg.vue?vue&type=style&index=0&id=61f328d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61f328d6"]])

export default __exports__